import { BASE_URL } from '@lib/constants';

export default async function saveAdvisorNotes(token, notes, prospectus_id) {
	const response = await fetch(`${BASE_URL}/wp-json/edu_api/advisor/notes/save`, {
		method: 'POST',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			notes: notes,
			prospectus_id: prospectus_id,
		}),
	});

	const responseData = await response.json();

	return responseData;
}
